import React, { useEffect, useState } from 'react';
import Icon from '@/components/Icon';
import { api } from '@/lib/api';

/**
 * Пикер ученика, у которого есть действующий paid_services-договор на дату.
 *
 *   <EligibleStudentPicker
 *      date="2026-05-04"
 *      excludeIds={[1, 2]}
 *      onPick={(student) => ...}
 *   />
 */
export default function EligibleStudentPicker({ date, excludeIds = [], onPick }) {
  const [search, setSearch] = useState('');
  const [rows, setRows]     = useState([]);
  const [loading, setLoad]  = useState(false);

  useEffect(() => {
    if (!date) return;
    let cancelled = false;
    setLoad(true);
    const t = setTimeout(() => {
      const qs = new URLSearchParams({ date });
      if (search.trim()) qs.set('search', search.trim());
      api.get('/api/extra-schedule/eligible-students?' + qs.toString())
        .then((res) => { if (!cancelled) setRows(res.rows || []); })
        .catch(() => { if (!cancelled) setRows([]); })
        .finally(() => { if (!cancelled) setLoad(false); });
    }, 200);
    return () => { cancelled = true; clearTimeout(t); };
  }, [date, search]);

  const filtered = rows.filter((r) => !excludeIds.includes(r.id));

  return (
    <div>
      <input
        className="sd-edit__input"
        placeholder="Поиск по ФИО ученика…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        autoFocus
      />
      <div style={{
        marginTop: 8, maxHeight: 240, overflowY: 'auto',
        border: '1px solid var(--border)', borderRadius: 7,
        background: 'var(--panel)',
      }}>
        {loading && filtered.length === 0 && (
          <div className="onec-picker__hint">Загрузка…</div>
        )}
        {!loading && filtered.length === 0 && (
          <div className="onec-picker__hint">
            {search
              ? 'Никого не найдено по запросу.'
              : 'Нет учеников с действующим договором «доп. услуги» на эту дату.'}
          </div>
        )}
        {filtered.map((s) => {
          const fio = [s.familyName, s.firstName, s.midName].filter(Boolean).join(' ');
          return (
            <button
              key={s.id}
              type="button"
              onClick={() => onPick(s)}
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                width: '100%', textAlign: 'left',
                padding: '8px 12px', border: 0, background: 'transparent',
                borderBottom: '1px solid var(--border)', cursor: 'pointer',
                fontSize: 13, color: 'var(--fg)', gap: 12,
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'var(--hover)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {fio}
              </span>
              <span className="muted" style={{ fontSize: 11, whiteSpace: 'nowrap' }}>
                <Icon name="doc" size={11} /> № {s.agreement.number}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
